export function ReactIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="lucide lucide-arrow-big-up h-[26px] w-[26px]"
    >
      <path d="M9 18v-6H5l7-7 7 7h-4v6H9z"></path>
    </svg>
  );
}
